__webpack_public_path__ = wordpress_constants.theme_path;
window.__webpack_public_path__ = __webpack_public_path__;